<template>
  <v-autocomplete
    v-model="inputTags"
    :label="label"
    :items="selectableTags"
    :loading="isLoading"
    :search-input.sync="searchQuery.id_or_name_cont"
    item-text="name"
    item-value="id"
    hide-selected
    return-object
    multiple
    :disabled="disabled"
    :filter="filter"
    @input="onInput"
    @change="setTags"
  >
    <template v-slot:selection="{ attrs, item, parent }">
      <v-chip
        v-if="item === Object(item)"
        v-bind="attrs"
        :input-value="item.id"
        label
        small
        outlined
        class="mx-1 my-1"
      >
        <span class="pr-2">
          {{ item.name }}
        </span>
        <v-icon small @click="parent.selectItem(item)"> mdi-close </v-icon>
      </v-chip>
    </template>
    <template v-slot:no-data>
      <v-list-item v-if="!searchQuery.id_or_name_cont"
        >タグ名を入力してください</v-list-item
      >
      <v-list-item v-else-if="isLoading">
        <v-list-item-title class="text-center">
          <v-progress-circular
            indeterminate
            color="blue-grey"
          ></v-progress-circular>
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-else>
        <v-list-item-title> 見つかりませんでした </v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import Qs from 'qs'
import { deserialize } from 'deserialize-json-api'

export default {
  name: 'MultipleTagSelector',
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: 'タグ'
    },
    filter: {
      type: Function,
      default: () => true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      debounceFetch: null,
      selectableTags: [],
      isLoading: false,
      inputTags: this.tags,
      searchQuery: { id_or_name_cont: '' }
    }
  },
  watch: {
    'searchQuery.id_or_name_cont': function (val) {
      if (
        !val ||
        (this.inputTags && this.inputTags.find((tag) => tag.name === val))
      ) {
        this.isLoading = false
        return
      }
      this.isLoading = true
      this.debounceFetch()
    },
    tags (value) {
      this.inputTags = [...value]
    }
  },
  mounted () {
    this.debounceFetch = _.debounce(this.fetchSelectableTag, 500)
    this.syncTags(this.tags)
  },
  methods: {
    onInput () {
      this.searchQuery.id_or_name_cont = ''
    },
    fetchSelectableTag () {
      axios
        .get('/api/tags', {
          params: { q: this.searchQuery },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(
          ({ data }) => {
            this.selectableTags = this.inputTags.concat(deserialize(data).data)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.messages
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => (this.isLoading = false))
    },
    setTags (value) {
      this.$emit('change-tag', value)
    },
    syncTags (tagValues) {
      if (
        !tagValues ||
        !tagValues.length ||
        this.includeSelectableTags(tagValues)
      ) {
        return
      }
      this.selectableTags.push(...tagValues)
    },
    includeSelectableTags (tagValues) {
      const tagValueIds = tagValues ? tagValues.map((tag) => tag.id) : []
      return !!this.selectableTags.find((item) => tagValueIds.includes(item.id))
    }
  }
}
</script>
